import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { IonicModule } from '@ionic/angular';
import { InterventionStatementModule } from '../../intervention-statement/intervention-statement.module';
import { ObservationsModule } from '../../observations/observations.module';

@NgModule({
	imports: [
		IonicModule,
		CommonModule,
		FormsModule,
		MatFormFieldModule,
		MatInputModule,
		ObservationsModule,
		InterventionStatementModule
	],
	exports: [],
	declarations: [],
	providers: []
})
export class ValidateActesModule { }